export default __webpack_public_path__ + "static/media/rare0.469132cc.gif";